import type { CampaignGroupType, CampaignStatus, CampaignType } from '~/types/graphql';
import type { Campaign } from '~/modules/campaign/types';

import { CAMPAIGN_TYPE, ACTIVE_TAB_TYPE_DEFAULT } from '~/constants/campaign';
import { INavigateKey } from '~/types/navigate';
import { ROUTE_PATH } from '~/config/navigate';
import { mapThemePageInfo } from '~/utils';

export * from './assigned';
export * from './campaign';
export * from './productVariant';
export * from './variant';

export const checkVariantsForMatch = (campaign: Campaign, query: string, themePages: any) => {
  if (campaign.type === CAMPAIGN_TYPE.PRICE) {
    return campaign.variants?.some((variant) =>
      variant?.price?.title?.toLowerCase().includes(query),
    );
  }

  if (campaign.type === CAMPAIGN_TYPE.URL) {
    return campaign.variants?.some((variant) => variant?.url?.title?.toLowerCase().includes(query));
  }

  return campaign.variants?.some((variant) => {
    if (!variant?.templateSuffix) return false;

    const dataThemePage = mapThemePageInfo(variant?.templateSuffix, themePages);
    return (dataThemePage?.label ?? variant?.templateSuffix)?.toLowerCase().includes(query);
  });
};

export const isTabMatchedStatus = (selectedTab?: string[], campaignStatus?: CampaignStatus) => {
  if (!campaignStatus || !selectedTab?.length) return true;

  return selectedTab.includes(ACTIVE_TAB_TYPE_DEFAULT) || selectedTab.includes(campaignStatus);
};
export const isTabMatchedType = (selectedTab: string, campaignStatus?: CampaignType) => {
  return selectedTab === ACTIVE_TAB_TYPE_DEFAULT || !selectedTab || selectedTab === campaignStatus;
};

export const getRoutesPathByCampaign = (campaign: {
  type?: CampaignType | CampaignGroupType;
  id: string;
}) => {
  switch (campaign.type) {
    case CAMPAIGN_TYPE.PRICE:
      return `${ROUTE_PATH[INavigateKey.CampaignPrice]}/${campaign.id}/detail`;

    case CAMPAIGN_TYPE.TEMPLATE_BUNDLE:
      return `${ROUTE_PATH[INavigateKey.CampaignMultipage]}/${campaign.id}/detail`;

    case CAMPAIGN_TYPE.TEMPLATE:
      return `${ROUTE_PATH[INavigateKey.CampaignTemplate]}/${campaign.id}/detail`;

    case CAMPAIGN_TYPE.URL:
      return `${ROUTE_PATH[INavigateKey.CampaignUrlRedirect]}/${campaign.id}/detail`;
  }

  return `${ROUTE_PATH[INavigateKey.CampaignTemplate]}/${campaign.id}/detail`;
};
